const API_BACKEND_SERVICE_URL =
  process.env.BACKEND_SERVICE_URL || "http://localhost:4001";

export const API = {
  GESLUB_SERVICE: API_BACKEND_SERVICE_URL,
};
